import Carousel from './carousel';
import { images } from '../constants';
import { useTranslation } from 'react-i18next';

function Projects() {

    const { t } = useTranslation();

    const projects = [
        {
            id: 1,
            title: t('projects.dzFast.title'),
            subtitle: t('projects.dzFast.subtitle'),
            description: t('projects.dzFast.description'),
            image: images.fast,
            links: [
                {
                    id: 1,
                    link: 'https://dz-fast.com',
                    path: "M19.902 4.098a3.75 3.75 0 0 0-5.304 0l-4.5 4.5a3.75 3.75 0 0 0 1.035 6.037.75.75 0 0 1-.646 1.353 5.25 5.25 0 0 1-1.449-8.45l4.5-4.5a5.25 5.25 0 1 1 7.424 7.424l-1.757 1.757a.75.75 0 1 1-1.06-1.06l1.757-1.757a3.75 3.75 0 0 0 0-5.304Zm-7.389 4.267a.75.75 0 0 1 1-.353 5.25 5.25 0 0 1 1.449 8.45l-4.5 4.5a5.25 5.25 0 1 1-7.424-7.424l1.757-1.757a.75.75 0 1 1 1.06 1.06l-1.757 1.757a3.75 3.75 0 1 0 5.304 5.304l4.5-4.5a3.75 3.75 0 0 0-1.035-6.037.75.75 0 0 1-.354-1Z",
                    size: '28'
                },
                {
                    id: 1,
                    link: 'https://www.linkedin.com/showcase/fast1'
                }
            ]
        },
        {
            id: 2,
            title: t('projects.idsWeb.title'),
            subtitle: t('projects.idsWeb.subtitle'),
            description: t('projects.idsWeb.description'),
            image: images.ids,
            links: [
                {
                    id: 1,
                    link: 'https://idslivraisonexpresscanada.com',
                    path: "M19.902 4.098a3.75 3.75 0 0 0-5.304 0l-4.5 4.5a3.75 3.75 0 0 0 1.035 6.037.75.75 0 0 1-.646 1.353 5.25 5.25 0 0 1-1.449-8.45l4.5-4.5a5.25 5.25 0 1 1 7.424 7.424l-1.757 1.757a.75.75 0 1 1-1.06-1.06l1.757-1.757a3.75 3.75 0 0 0 0-5.304Zm-7.389 4.267a.75.75 0 0 1 1-.353 5.25 5.25 0 0 1 1.449 8.45l-4.5 4.5a5.25 5.25 0 1 1-7.424-7.424l1.757-1.757a.75.75 0 1 1 1.06 1.06l-1.757 1.757a3.75 3.75 0 1 0 5.304 5.304l4.5-4.5a3.75 3.75 0 0 0-1.035-6.037.75.75 0 0 1-.354-1Z",
                    size: '28'
                }
            ]
        },
        {
            id: 3,
            title: t('projects.idsMobile.title'),
            subtitle: t('projects.idsMobile.subtitle'),
            description: t('projects.idsMobile.description'),
            image: images.ids,
            links: [
                {
                    id: 1,
                    link: 'https://play.google.com/store/apps/details?id=ids.livraison.express',
                    path: "M12.75 10.875l3.15-3.375L3.675 0.9C3.6 0.825 3.45 0.825 3.225 0.75L12.75 10.875zM17.25 15.75l4.425-2.4c0.525-0.3 0.825-0.75 0.825-1.35s-0.3-1.125-0.825-1.35L17.25 8.25l-3.525 3.75L17.25 15.75zM1.8 1.425C1.575 1.65 1.5 1.95 1.5 2.25V21.75c0 0.3 0.075 0.6 0.3 0.9L11.7 12 1.8 1.425zM12.75 13.125L3.225 23.25c0.15 0 0.3-0.075 0.45-0.15L15.9 16.5 12.75 13.125z",
                    size: '25'
                }
            ]
        },
        {
            id: 4,
            title: t('projects.getNotified.title'),
            subtitle: t('projects.getNotified.subtitle'),
            description: t('projects.getNotified.description'),
            image: images.getNotified,
            links: [
                {
                    id: 2,
                    link: 'https://github.com/AliAmeur20/get-notified',
                    path: "M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z",
                    size: '32'
                }
            ]
        }
    ];

    return (
        <div className='bg-secondary overflow-hidden'>
            <div className='container mx-auto py-20 md:py-24 space-y-16 md:space-y-20'>
                <div className="text-center text-secondary-content max-w-3xl mx-auto px-2">
                    <h2 className="text-3xl md:text-4xl font-bold mb-4">
                        {t('projects.heading')}
                    </h2>
                    <p className="text-lg md:text-xl">
                        {t('projects.subheading')}
                    </p>
                </div>
                <div className='flex justify-end px-3 md:px-8'>
                    <div className='flex justify-end'>
                        <Carousel elements={projects} cardType='project' color='secondary' />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Projects;